import React, { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";

// components
import Header from "../components/Header/Header";
import BlogCard from "../components/Blog/BlogCard";
import BlogSidebar from "../components/Blog/BlogSidebar";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import Loading from "../components/shared/Loading";
import Footer from "../components/Footer/Footer";

// context
import { UserData } from "../contexts/UserInfoContext";

// API
import { getData, postData } from "../services/API";
import config from "../modules/blog/config.json";
import { HiArrowLongLeft, HiArrowLongRight } from "react-icons/hi2";
import { toFarsiNumber } from "../helper/helper";
import ScrollTop from "../components/shared/ScrollTop";
import Compare from "../components/Compare/Compare";
import { useLocation, useParams } from "react-router-dom";
import BlogCardLoading from "../components/Blog/BlogCardLoading";

const Magazine = ({ type }) => {
  const {
    api_url: { get_all_posts },
  } = config;

  const { user } = useContext(UserData);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pages, setPages] = useState([]);

  const headerRef = useRef(null);

  const toastErr = useRef(null);

  const loc = useLocation();

  const params = useParams();
  const categorySlug = params.slug;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    if (loc.pathname === "/magazine") {
      setLoading(true);
      postData("/blog/index", { type }, true)
        .then((res) => {
          setPosts(res.data.data);
          setPages(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toastErr.current.show({
            severity: "error",
            summary: "خطا هنگام دریافت اطلاعات از سرور",
            detail: "لطفا دوباره صفحه را بارگذاری کنید",
            life: 3500,
          });
        });
    } else {
      setLoading(true);

      postData(`/blog/category/view-posts`, { type, slug: categorySlug }, true)
        .then((res) => {
          setPosts(res.data);
          setPages(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toastErr.current.show({
            severity: "error",
            summary: "خطا هنگام دریافت اطلاعات از سرور",
            detail: "لطفا دوباره صفحه را بارگذاری کنید",
            life: 3500,
          });
        });
    }
  }, [loc]);

  const prevPage = (link) => {
    if (headerRef.current) {
      headerRef.current.scrollIntoView({ behavior: "smooth" });
    }
    
    setLoading(true);
    postData(link.url, { type }, true)
      .then((res) => {
        setPosts(res.data.data);
        setPages(res.data);
        setLoading(false);
      })
      .catch((err) => {});
  };

  const nextPage = (link) => {
    if (headerRef.current) {
      headerRef.current.scrollIntoView({ behavior: "smooth" });
    }

    setLoading(true);
    postData(link.url, { type }, true)
      .then((res) => {
        setPosts(res.data.data);
        setPages(res.data);
        setLoading(false);
      })
      .catch((err) => {});
  };

  const pageNumber = (link) => {
    if (headerRef.current) {
      headerRef.current.scrollIntoView({ behavior: "smooth" });
    }

    setLoading(true);
    postData(link.url, { type }, true)
      .then((res) => {
        setPosts(res.data.data);
        setPages(res.data);
        setLoading(false);
      })
      .catch((err) => {});
  };

  return (
    <div className="blog flex flex-col items-center lg:gap-10 justify-center">
      <Header ref={headerRef} />
      <MobileNavbar />
      <MobileHeader />
      <Toast ref={toastErr} />
      <Compare />
      <ScrollTop />

      <div className="w-full max-w-[1300px] blog-content h-auto flex gap-10 2xl:p-0 p-3 md:flex-row sm:items-start flex-col-reverse items-center">
        <div className="w-full flex flex-col gap-10">
          {!loading ? (
            <div className="blog-post w-full h-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-5">
              {posts.length > 0 ? (
                posts.map((post) => <BlogCard key={post.id} data={post} />)
              ) : (
                <span className="!text-gray-200">پستی وجود ندارد !</span>
              )}
            </div>
          ) : (
            <div className="blog-post w-full h-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-5">
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
              <BlogCardLoading />
            </div>
          )}

          {/* pagination */}
          {pages?.from && (
            <div className="flex items-center justify-center gap-3">
              {pages.links.map((link, index, arr) =>
                index === 0 ? (
                  <button
                    disabled={link.url === null ? true : false}
                    onClick={() => prevPage(link)}
                    className={`w-[46px] h-[46px] disabled:opacity-70 disabled:cursor-default cursor-pointer flex justify-center items-center bg-white text-gray-800 hover:text-white text-lg hover:bg-yellow-700 rounded-lg group transition-all duration-300`}
                  >
                    <HiArrowLongRight className="text-2xl text-gray-800 group-hover:text-white" />
                  </button>
                ) : !index == 0 && index !== arr.length - 1 ? (
                  <button
                    onClick={() => pageNumber(link)}
                    className={`w-[46px] h-[46px] cursor-pointer flex justify-center items-center  text-lg ${
                      link.active
                        ? "text-white bg-yellow-700"
                        : "bg-white text-gray-800"
                    } hover:bg-yellow-700 hover:text-white rounded-lg group transition-all duration-300`}
                  >
                    {toFarsiNumber(link.label)}
                  </button>
                ) : (
                  index === arr.length - 1 && (
                    <button
                      onClick={() => nextPage(link)}
                      disabled={link.url === null ? true : false}
                      className={`w-[46px] h-[46px] disabled:opacity-70 disabled:cursor-default flex cursor-pointer justify-center items-center bg-white text-gray-800 hover:text-white text-lg hover:bg-yellow-700 rounded-lg group transition-all duration-300`}
                    >
                      <HiArrowLongLeft className="text-2xl text-gray-800 group-hover:text-white" />
                    </button>
                  )
                )
              )}
            </div>
          )}
        </div>

        <BlogSidebar type={type} setPosts={setPosts} setPages={setPages} />
      </div>

      <Footer />
    </div>
  );
};

export default Magazine;
{
  /* <div className="flex items-center justify-center gap-3">
              <button className="w-[46px] h-[46px] flex justify-center items-center bg-white text-gray-800 hover:text-white text-lg hover:bg-yellow-700 rounded-lg group transition-all duration-300">
                <HiArrowLongRight className="text-2xl text-gray-800 group-hover:text-white" />
              </button>

              <button className="w-[46px] h-[46px] flex justify-center items-center text-white text-lg bg-yellow-700 rounded-lg group transition-all duration-300">
                {toFarsiNumber(1)}
              </button>

              <button className="w-[46px] h-[46px] flex justify-center items-center bg-white text-gray-800 hover:text-white text-lg hover:bg-yellow-700 rounded-lg group transition-all duration-300">
                <HiArrowLongLeft className="text-2xl text-gray-800 group-hover:text-white" />
              </button> </div>*/
}
